import recommendationsFragment from './Fragments/recommendationsFragment'

const getRecommendationSectionsQuery = /* GraphQL */ `
  query GetRecommendationSections(
    $sections: [String]
    $skuBaseNumbers: [String]
    $skuVariantNumbers: [String]
    $articleIds: [String]
    $ymmData: YmmDataInput
    $keywords: String
    $userVin: String
    $webUserGuid: String
  ) {
    recommendationSections(
      sections: $sections
      skuBaseNumbers: $skuBaseNumbers
      skuVariantNumbers: $skuVariantNumbers
      articleIds: $articleIds
      ymmData: $ymmData
      keywords: $keywords
      userVin: $userVin
      webUserGuid: $webUserGuid
    ) {
      sectionType
      treatment
      recommendationGroups {
        title
        subtitle
        isExpandable
        displayType
        recommendations {
          __typename
          ... on LandingPage {
            landingPageDetails {
              displayValue
              thumbnailImageUrl
              field
              facetOptionLink {
                url
                noFollow
              }
            }
          }
          ... on Category {
            categoryName
            url
          }
          ... on Product {
            skuVariant
            skuBase
            publicSkuBaseDetails(webUserGuid: $webUserGuid) {
              displayTitle
              skuBaseNumber
              productPageUrl
              thumbnailImageLink
              rating
              pricing {
                salePrice
                salePriceString
              }
              skuVariantSummaries {
                skuNumber
              }
              segmentCategorization
              brand
            }
            publicSkuVariantDetails(webUserGuid: $webUserGuid) {
              displayTitle
              skuVariantNumber
              kit {
                skuBaseComponents {
                  kitSkuNumber
                }
                skuVariantComponents {
                  kitSkuNumber
                }
              }
            }
          }
          ... on Article {
            articleId
            articleDetails {
              id
              misoId
              title
              authors
              description
              createdAt
              lastDeployedAt
              deployDate
              articleThumbnailUrl
              url
              versionId
            }
          }
        }
      }
    }
  }
`

export default getRecommendationSectionsQuery
